module.exports = __webpack_public_path__ + "static/media/20ECE25.60967888.jpg";